/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/fragments-delivery-api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../clients/fragments-delivery-api-client";
import type { FragmentsDeliveryAPIClientEnableDeliveryMutationRequest, FragmentsDeliveryAPIClientEnableDeliveryMutationResponse, FragmentsDeliveryAPIClientEnableDeliveryPathParams, FragmentsDeliveryAPIClientEnableDelivery404 } from "../models/FragmentsDeliveryAPIClientEnableDelivery";

function getFragmentsDeliveryAPIClientEnableDeliveryUrl(fragmentId: FragmentsDeliveryAPIClientEnableDeliveryPathParams["fragmentId"]) {
  const res = { method: 'POST', url: `/delivery/${fragmentId}/enable` as const }  
  return res
}

/**
 * @description Enables delivery for a fragment and triggers delivery jobs for its existing assets
 * @summary Enable delivery for an existing fragment
 * {@link /delivery/:fragmentId/enable}
 */
export async function fragmentsDeliveryAPIClientEnableDelivery(fragmentId: FragmentsDeliveryAPIClientEnableDeliveryPathParams["fragmentId"], data?: FragmentsDeliveryAPIClientEnableDeliveryMutationRequest, config: Partial<RequestConfig<FragmentsDeliveryAPIClientEnableDeliveryMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<FragmentsDeliveryAPIClientEnableDeliveryMutationResponse, ResponseErrorConfig<FragmentsDeliveryAPIClientEnableDelivery404>, FragmentsDeliveryAPIClientEnableDeliveryMutationRequest>({ method : "POST", url : getFragmentsDeliveryAPIClientEnableDeliveryUrl(fragmentId).url.toString(), data : requestData, ... requestConfig })  
  return res.data
}